import { render } from "./RequestResetPassword.vue?vue&type=template&id=76e562c4&scoped=true"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=76e562c4&lang=scss&scoped=true"

import exportComponent from "/Users/oscarbout/Code/3birdhrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e562c4"]])

export default __exports__